if (!customElements.get('sort-collection')) {
  class SortCollection extends HTMLElement {
    constructor() {
      super();
      this.CollectionFiltersForm = document.querySelector('product-filters-form') || null;
      this.addEventListener('change', (event) => {
        this.handleChange(event);
      });
    }

    handleChange(event) {
      const value = event.target.value;
      const url = new URL(window.location);
      const params = new URLSearchParams(url.search);

      params.delete('sort_by');
      if (value !== '') {
        params.set('sort_by', value);
      }

      this.CollectionFiltersForm?.renderPage(params.toString());
    }
  }
  window.SortCollection = SortCollection;
  customElements.define('sort-collection', SortCollection);
}
